import { inject } from '@angular/core';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import { AuthService } from './auth-service';

export const tenantGuard: CanActivateFn = (route, state): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const tenant = authService.loginUser()?.tenant;

  if (authService.isAlreadyLoggedIn() && tenant !== undefined) {
    if (authService.verifyTenant(tenant)) {
      return true;
    }
    else {
      return router.createUrlTree(['/unauthorized']);
    }
  }

  authService.login(state.url);
  return false;
}
